import axios from "axios";
import config from '../constants/config';
import { handleApiError } from "../utils/apiErrorHandler";

const API_URL = config.apiBaseUrl; // your backend URL
const JWT_SECRET_KEY = config.JWT_SECRET_KEY;

// let authToken = '';
// try {
//   const user = JSON.parse(localStorage.getItem("user") || '{}');
//   authToken = user?.authToken || '';
// } catch (err) {
//   console.error("Error parsing user from localStorage:", err);
// }

const DriverService = {

  saveVehicle: async (params) => {
    const user = JSON.parse(localStorage.getItem("user") || '{}');
    const authToken = user?.authToken || '';
    try {

      const response = await axios.post(`${API_URL}/driver/save_vehicle`,
        params,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `${JWT_SECRET_KEY} ${authToken}`
          },
        });

      return response.data;
    } catch (error) {
      handleApiError(error);
    }
  },

  getVehicleList: async (uId) => {
    const user = JSON.parse(localStorage.getItem("user") || '{}');
    const authToken = user?.authToken || '';
    try {
      const response = await axios.post(`${API_URL}/driver/get_vehicle_listing`, { uId: uId }, {
        headers: {
          'Authorization': `${JWT_SECRET_KEY} ${authToken}`
        }
      });
      return response.data;
    } catch (error) {
      handleApiError(error);
    }
  },

  getApprovedVehicleList: async (uId) => {
    const user = JSON.parse(localStorage.getItem("user") || '{}');
    const authToken = user?.authToken || '';
    try {
      const response = await axios.post(`${API_URL}/driver/get_approved_vehicle`, { uId: uId }, {
        headers: {
          'Authorization': `${JWT_SECRET_KEY} ${authToken}`
        }
      });
      return response.data;
    } catch (error) {
      handleApiError(error);
    }
  },

  saveStartLocation: async (params) => {
    const user = JSON.parse(localStorage.getItem("user") || '{}');
    const authToken = user?.authToken || '';
    try {
      const response = await axios.post(`${API_URL}/driver/save_driver_location`, params, {
        headers: {
          'Authorization': `${JWT_SECRET_KEY} ${authToken}`
        }
      });
      return response.data.data;
    } catch (error) {
      handleApiError(error);
    }
  },

  getDrivingDrivers: async (params) => {

    const authToken = params.authToken;
    delete params.authToken;

    try {
      const response = await axios.post(`${API_URL}/driver/get_driving_driver_list`, params, {
        headers: {
          'Authorization': `${JWT_SECRET_KEY} ${authToken}`
        }
      });
      return response.data.data;
    } catch (error) {
      handleApiError(error);
    }
  },

  getBookedDriver: async (params) => {

    const authToken = params.authToken;
    delete params.authToken;

    try {
      const response = await axios.post(`${API_URL}/driver/get_booked_driver`, params, {
        headers: {
          'Authorization': `${JWT_SECRET_KEY} ${authToken}`
        }
      });
      return response.data.data;
    } catch (error) {
      handleApiError(error);
    }
  },

  updateDriverCurrentLocation: async (params) => {
    const authToken = params.authToken;
    delete params.authToken;

    try {
      const response = await axios.post(`${API_URL}/driver/save_current_location_of_driver`, params, {
        headers: {
          'Authorization': `${JWT_SECRET_KEY} ${authToken}`
        }
      });
      return response.data.data;
    } catch (error) {
      handleApiError(error);
    }
  },

  getDriverReply: async (params) => {
    const user = JSON.parse(localStorage.getItem("user") || '{}');
    const authToken = user?.authToken || '';
    try {
      const response = await axios.post(`${API_URL}/driver/get_driver_reply`, params, {
        headers: {
          'Authorization': `${JWT_SECRET_KEY} ${authToken}`
        }
      });
      return response.data.data;
    } catch (error) {
      handleApiError(error);
    }
  },

  verifyOTP: async (params) => {
    const user = JSON.parse(localStorage.getItem("user") || '{}');
    const authToken = user?.authToken || '';
    try {
      const response = await axios.post(`${API_URL}/driver/verify_otp`, params, {
        headers: {
          'Authorization': `${JWT_SECRET_KEY} ${authToken}`
        }
      });
      return response.data;
    } catch (error) {
      handleApiError(error);
    }
  },

  getCurrentFullAddress: async (params) => {
    const user = JSON.parse(localStorage.getItem("user") || '{}');
    const authToken = user?.authToken || '';
    try {
      const response = await axios.post(`${API_URL}/driver/get_current_address`, params, {
        headers: {
          'Authorization': `${JWT_SECRET_KEY} ${authToken}`
        }
      });
      return response.data;
    } catch (error) {
      handleApiError(error);
    }
  },

  cancelToRide: async (params) => {
    const user = JSON.parse(localStorage.getItem("user") || '{}');
    const authToken = user?.authToken || '';
    try {
      const response = await axios.post(`${API_URL}/driver/cancel_to_ride`, params, {
        headers: {
          'Authorization': `${JWT_SECRET_KEY} ${authToken}`
        }
      });
      return response.data;
    } catch (error) {
      handleApiError(error);
    }
  },

  getVehicleDetail: async (params) => {
    const user = JSON.parse(localStorage.getItem("user") || '{}');
    const authToken = user?.authToken || '';

    try {
      const response = await axios.post(`${API_URL}/driver/get_vehicle_details`, params, {
        headers: {
          'Authorization': `${JWT_SECRET_KEY} ${authToken}`
        }
      });
      return response.data;
    } catch (error) {
      handleApiError(error);
    }
  },

  getCurrentRouteDetail: async (DriveNo) => {
    const user = JSON.parse(localStorage.getItem("user") || '{}');
    const authToken = user?.authToken || '';

    try {
      const response = await axios.post(`${API_URL}/driver/get_current_route_location`, { DriveNo: DriveNo }, {
        headers: {
          'Authorization': `${JWT_SECRET_KEY} ${authToken}`
        }
      });
      return response.data;
    } catch (error) {
      handleApiError(error);
    }
  },

  getPassengerByDriveNo: async (params) => {
    const authToken = params.authToken;
    delete params.authToken;

    try {
      const response = await axios.post(`${API_URL}/driver/get_passenger_by_driveno`, params, {
        headers: {
          'Authorization': `${JWT_SECRET_KEY} ${authToken}`
        }
      });
      return response.data;
    } catch (error) {
      handleApiError(error);
    }
  },


}


export default DriverService;